import { z } from "zod";

export const eventSchema = z.object({
  distinctId: z.string(),
  disabled: z.boolean().default(false),
});
